// Generic placeholder for sections whose real surface is built in the surfaces workflow.
// The shell, routing, theming, and RBAC gating around it are already live.
export function PlaceholderPage({ title, bind }: { title: string; bind?: string }) {
  return (
    <div className="page">
      <h1 className="page__title">{title}</h1>
      <p className="page__note">
        This surface is built in the upcoming surfaces workflow. Navigation, theming, update-control,
        and RBAC gating are live around it.
      </p>
      {bind ? <p className="page__bind">Will bind to {bind}.</p> : null}
    </div>
  );
}
